import React from 'react';
import { format_curency } from 'utils';

const HorizontalGift = ({ giftData, handleOpenDetailInfo }) => (
  <div className='h-fit w-fit p-1 lg:p-0' onClick={() => handleOpenDetailInfo(giftData)}>
    <div className='mb-4 flex w-full cursor-pointer bg-white lg:mb-0 lg:block lg:w-[160px] lg:overflow-hidden lg:rounded-lg'>
      <div className='flex h-20 w-25 lg:h-[108px] lg:w-full items-center justify-center'>
        <img
          className='h-[100%] rounded-lg object-contain lg:rounded-none'
          src={giftData.imageLink[0]?.fullLink || '/assets/images/carousel/pc/Voucher2.png'}
          // src='assets/images/carousel/pc/Voucher2.png'
          alt=''
        />
      </div>
      <div className='px-4 py-0 font-roboto-regular lg:py-5 lg:pb-2'>
        <p className='line-clamp-2 text-[16px]'>{giftData.giftInfor.name}</p>
        <p className='line-clamp-2 text-14px text-0090F0'>
          {format_curency(giftData.giftInfor.requiredCoin)} điểm
        </p>
      </div>
    </div>
  </div>
);
export default HorizontalGift;
